module.exports = __webpack_public_path__ + "static/media/28.13b6d953.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/28.svg
// module id = 145
// module chunks = 0